import { useState } from 'react';

const PHONE = [['off', 'Don’t ask'], ['optional', 'Ask, but optional'], ['required', 'Required']];
const DEFAULTS = { phone: 'optional', company: false, message: false };

export function LeadCapturePanel({ bot, updateBot, notify }) {
  const current = { ...DEFAULTS, ...(bot.leadCapture || {}) };
  const [draft, setDraft] = useState(current);
  const dirty = JSON.stringify(draft) !== JSON.stringify(current);

  function save() {
    updateBot({ leadCapture: draft });
    notify('success', 'Lead capture form updated');
  }

  return (
    <div>
      <div className="panel-header">
        <h1>Lead capture</h1>
        <p>Choose what the chat widget asks visitors who leave their contact details. Name and email are always asked.</p>
      </div>
      <div className="card">
        <fieldset className="field">
          <legend className="lead-legend">Phone number</legend>
          <div className="lead-options" role="radiogroup" aria-label="Phone number field">
            {PHONE.map(([value, label]) => (
              <label key={value} className={'lead-option' + (draft.phone === value ? ' selected' : '')}>
                <input type="radio" name="lead-phone" value={value} checked={draft.phone === value} onChange={() => setDraft({ ...draft, phone: value })} />
                <span>{label}</span>
              </label>
            ))}
          </div>
          <div className="hint">Numbers are checked for format: 10 digits, or + and the country code.</div>
        </fieldset>

        <div className="field">
          <div className="toggle-row">
            <div className="toggle-copy"><strong>Company</strong><span>Optional text field, up to 80 characters.</span></div>
            <button type="button" className={'switch' + (draft.company ? ' on' : '')} aria-pressed={draft.company} aria-label="Ask for company" onClick={() => setDraft({ ...draft, company: !draft.company })}><span className="knob" /></button>
          </div>
        </div>
        <div className="field">
          <div className="toggle-row">
            <div className="toggle-copy"><strong>Message</strong><span>Optional “How can we help?” box, up to 500 characters.</span></div>
            <button type="button" className={'switch' + (draft.message ? ' on' : '')} aria-pressed={draft.message} aria-label="Ask for a message" onClick={() => setDraft({ ...draft, message: !draft.message })}><span className="knob" /></button>
          </div>
        </div>

        <div className="field">
          <div className="preview-label">What visitors see</div>
          <div className="lead-preview" aria-label="Lead form preview">
            <div className="lead-preview-title">Share your contact details</div>
            <div className="lead-preview-input">Your name</div>
            <div className="lead-preview-input">Email address</div>
            {draft.phone !== 'off' && <div className="lead-preview-input">{draft.phone === 'required' ? 'Phone number' : 'Phone number (optional)'}</div>}
            {draft.company && <div className="lead-preview-input">Company (optional)</div>}
            {draft.message && <div className="lead-preview-input tall">How can we help? (optional)</div>}
          </div>
        </div>

        <div className="actions-row">
          <button className="btn-primary" disabled={!dirty} onClick={save}>Save changes</button>
          {dirty && <button className="btn-secondary" onClick={() => setDraft(current)}>Discard</button>}
        </div>
      </div>
    </div>
  );
}
